module.exports = __webpack_public_path__ + "img/skridsko_snois2.7642f96d.jpg";